//src/app/features/payments/PaymentCards/index.tsx
import useConfirmContinue from 'app/hooks/useConfirmContinue';
import {
  useGetCardsQuery,
  useCreateCardMutation,
  useDeleteCardMutation,
  useSetDefaultCardMutation,
} from 'app/services/payments/cards';
import { Card } from 'app/services/responseTypes';
import { AddIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import CreditCard from 'Components/CreditCard';
import { successToast } from 'Components/Notifications';
import PaginatedList from 'Components/Pagination/PaginatedList';
import { useConfirmDeleteModal } from 'Components/Popups/ConfirmDeletePopup';
import Spinner from 'Components/Spinner';
import React from 'react';

const PaymentCards = () => {
  const { data } = useGetCardsQuery();
  const [DeleteCard] = useDeleteCardMutation();
  const [SetDefaultCard] = useSetDefaultCardMutation();

  const confirmDelete = useConfirmDeleteModal();
  const confirmContinue = useConfirmContinue();
  if (!data) return <Spinner />;

  return (
    <PaginatedList
      className="p-4"
      data={data?.cards}
      notFoundTitle="No Cards Added"
      renderItem={(card) => (
        <CreditCard
          defaultCardId={data.default_payment_method}
          card={card}
          onDelete={() => async () =>
            confirmDelete('Credit Card', () => {
              return DeleteCard(card.id).unwrap();
            })}
          setDefault={() => async () => {
            confirmContinue({
              confirmText: 'Continue',
              title: `Set **** **** **** ${card.last_4_digits} Card As Default Card`,
              text: 'Are you sure you want to continue ?',
              onConfirm: () =>
                SetDefaultCard(card.id)
                  .unwrap()
                  .then(() =>
                    successToast(
                      `Your default card has been successfully updated`,
                    ),
                  ),
            });
          }}
        />
      )}
    />
  );
};

export default PaymentCards;
